'use strict';

/**
 * Load the props defined in the HTMLElement by the attributes data-props-*
 *
 * @param {Component.props} props
 * @param {HTMLElement} el
 * @returns {Component.props}
 */
function loadProps(props, el) {
    var i;

    props = props || {};

    if (el.hasAttributes && el.hasAttributes()) {
        i = el.attributes.length;

        while (--i > -1) {
            if (el.attributes[i].name.substr(0, 11) === 'data-props-') {
                props[el.attributes[i].name.substr(11)] = el.attributes[i].value;
            }
        }
    }

    return props;
}

module.exports = loadProps;
